import { styled } from "@mui/material/styles";
import { Box, Card, Paper } from "@mui/material";

export const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: "#f8fafc",
  minHeight: "100%",
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
}));

export const LogPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: 12,
  border: `1px solid ${theme.palette.divider}`,
  background:
    "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(250,250,252,1) 100%)",
}));

export const TimelineLine = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: 17,
  width: 2,
  backgroundColor: theme.palette.divider,
}));

export const GridWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 16,
  overflow: "hidden",
}));
